function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function InitialiseThankyouPage()
{
    var qp      = ParseQP();
    var targets = document.querySelectorAll( ".success_text" );

    for( var i = 0; i < targets.length; i++ )
    {
        var target = targets[ i ];
        if( ( qp ) && qp.type )
        {
            if( target.dataset.type == qp.type )
            {
                target.classList.remove( "hidden" );
            }
        }
    }
}

window.addEventListener( "DOMContentLoaded", function( e )
{
    InitialiseThankyouPage();
} );